import { initializeGallerySlider, handleRefreshModal } from './utils/slick.js'
;(function ($) {
    'use strict'

    gsap.registerPlugin(ScrollTrigger)

    $(function () {
        // Initialitze gallery slick slider in modal
        $('.modal').one('shown.bs.modal', initializeGallerySlider)

        // Reposition modal on resize
        $('.modal').on('hidden.bs.modal', function () {
            handleRefreshModal(this)
        })

        const timelineTracker = document.getElementById('timeline-tracker')

        // Track timeline progress
        ScrollTrigger.create({
            trigger: '#timeline',
            start: 'top center',
            end: 'bottom center',
            onUpdate: (self) => {
                gsap.to(timelineTracker, {
                    top: () => `${self.progress * 100}%`,
                })
            },
        })

        // Recalculate end position when images are loaded or when an error occurs
        ScrollTrigger.matchMedia({
            '(max-width: 767.98px)': function () {
                let timeoutID
                $('.event-image > img').one('load error', () => {
                    clearTimeout(timeoutID)
                    timeoutID = setTimeout(() => {
                        ScrollTrigger.refresh()
                    }, 2000)
                })
            },
        })

        gsap.utils.toArray('#timeline .event-year').forEach((year) => {
            ScrollTrigger.create({
                trigger: year,
                start: 'center center',
                onEnter: (self) => {
                    year.classList.add('passed')
                },
                onLeaveBack: (self) => {
                    year.classList.remove('passed')
                },
            })
        })
    }) // END Document Ready
})(jQuery)
